import request from '../request';

// 获取工具列表
export function getToolList(params) {
    return request('/tool/toolList', {
        method: 'GET',
        params
    });
}

// 获取工具详情
export function getToolDetail(params) {
    return request('/tool/getTool', {
        method: 'GET',
        params
    });
}

// 获取工具分类
export function getToolTabs(params) {
    return request('/tool/getType', {
        method: 'GET',
        params
    });
}

// 浏览
export function viewTool(params) {
    return request('/tool/viewTool', {
        method: 'GET',
        params
    });
}
